// 简体中文。类型是 `Messages` —— en.ts 里加了 key 而这里没补，
// 就是编译错误，不会悄悄漏成英文。

import type { Messages } from './en';

export const zh: Messages = {
  "web.severity": "严重程度",
  "web.title": "Web 监控",
  "web.description": "真实用户访问、JavaScript 错误与独立浏览器检查",
  "web.chooseApp": "选择此项目的 Web App",
  "web.noApps": "先创建带明确标识的 Web App，再接入访问采集",
  "web.performance": "性能",
  "web.checks": "主动检查",
  "web.errors": "错误",
  "web.visits": "采样访问",
  "web.documents": "文档访问",
  "web.errorRate": "访问错误率估计",
  "web.rumHint": "分位数来自采样访问，并按设备分别统计。文档指标与 SPA 路由就绪耗时分开展示；没有数据不代表通过。",
  "web.samples": "样本数",
  "web.device": "设备",
  "web.mobile": "移动端",
  "web.desktop": "桌面端",
  "web.all": "全部",
  "web.environment": "环境",
  "web.release": "版本",
  "web.route": "路由模板",
  "web.hours": "时间窗口（小时）",
  "web.metric": "指标",
  "web.assessment": "评估",
  "web.insufficient": "样本不足",
  "web.attention": "需要关注",
  "web.good": "良好",
  "web.observed": "已观测",
  "web.coverage": "缺失指标统计",
  "web.recent": "最近访问",
  "web.diagnostics": "诊断信息",
  "web.empty": "当前范围没有观测数据",
  "web.errorHint": "汇总最近 500 条错误事件；关联访问仅包含携带可选 RUM 上下文的事件",
  "web.occurrences": "次数",
  "web.correlated": "关联访问",
  "web.lastSeen": "最近出现",
  "web.create": "创建检查",
  "web.edit": "编辑检查",
  "web.run": "立即检查",
  "web.refresh": "刷新",
  "web.runnerMissing": "尚未配置浏览器 runner，当前无法执行检查",
  "web.labHint": "实验室结果与真实用户分位数分开。TBT 不是 INP；本地检查不证明搜索引擎已收录。",
  "web.name": "名称",
  "web.url": "URL",
  "web.policy": "页面策略",
  "web.public": "公开且允许收录",
  "web.private": "私有／不收录",
  "web.ready": "就绪元素选择器",
  "web.auth": "Runner 认证配置名",
  "web.authHint": "凭据只保存在 runner，按项目和 App 隔离",
  "web.origins": "额外允许的公开来源（每行一个）",
  "web.schedule": "启用定时检查",
  "web.interval": "间隔（秒，最少 900）",
  "web.lighthouse": "运行 Lighthouse 性能审计",
  "web.alerts": "持续失败及恢复时通知",
  "web.threshold": "通知前连续失败次数",
  "web.advanced": "操作步骤（JSON，可选）",
  "web.stepsHint": "支持 click、waitFor、assertText。请使用专用账号，只配置只读操作流程。",
  "web.save": "保存",
  "web.cancel": "取消",
  "web.delete": "删除检查及历史",
  "web.confirmDelete": "确认删除",
  "web.failed": "操作失败",
  "web.findings": "检查结果",
  "web.rule": "规则",
  "web.evidence": "依据",
  "web.advice": "修复建议",
  "web.profile": "条件及工具版本",
  "web.queued": "排队中",
  "web.running": "执行中",
  "web.passed": "通过",
  "web.siteFailed": "检查未通过",
  "web.monitorError": "监控执行错误",
  "web.cancelled": "已取消",
  "web.unknown": "尚未检查",
  "web.degraded": "已观测到失败",
  "web.failing": "持续失败",
  "web.noFindings": "已检查范围内未发现问题",
  "web.retention": "保留 {days} 天",
  "web.sampleRates": "采样概率",
  "web.history": "最近检查记录",
  "web.budgetLcp": "LCP 阈值（毫秒）",
  "web.budgetTbt": "TBT 阈值（毫秒）",
  "web.budgetCls": "CLS 阈值",

  "releaseView.noFiles": "尚未上传调试文件",
  "releaseView.uploadedUnchecked": "文件已存储，尚未验证格式",
  "releaseView.cliHint": "用 sentori 完成配置、源码收集、调试文件上传和存储校验。不依赖 Git；使用 Git 时可通过 --git-tag 指定准确的标签。",
  "releaseView.sourceZipHint": "上传该构建的 UTF-8 源码 ZIP，保留相对项目根目录的路径。解压后最多 64 MiB，单文件最多 512 KiB；也兼容旧版源码 JSON。",
  "releaseView.validationHint": "这里只列出已上传的调试文件。格式验证通过不代表已匹配构建或事件；不运行 JavaScript 的原生应用不需要 Source Map。",
  "releaseView.fileStatus": "{kind}：{status} · {count} 个文件",
  "releaseView.notUploaded": "未上传",
  "artifact.sourceMap": "Source Map（源码映射）",
  "artifact.dsym": "dSYM",
  "artifact.proguard": "ProGuard 混淆映射",
  "artifact.sourceBundle": "源码包",
  "bench.noDocuments": "没有打开的标签",
  "bench.openDocument": "从导航或资源列表打开页面，开始工作",
  "bench.reopenDocument": "重新打开刚才的页面",
  "releaseView.selected": "所选版本",
  "releaseView.backToList": "返回列表",
  "releaseView.outsideList": "所选版本不在当前结果中",
  "releaseView.sections": "版本详情分区",
  "shell.saasBy": "由 {name} 提供 SaaS",
  "shell.saas": "Sentori Cloud · SaaS",
  "shell.selfHostedBy": "由 {operator} 自托管 · {name}",
  "shell.selfHostedInstance": "自托管 · {name}",
  "shell.selfHosted": "自托管实例",
  "shell.instanceUnknown": "实例信息暂不可用",
  "shell.instanceDetails": "实例与版本",
  "shell.interfaceVersion": "管理界面 {version}",
  "shell.serviceVersion": "数据服务 {version}",
  "shell.interface": "管理界面版本",
  "shell.service": "数据服务版本",
  "shell.deploymentMode": "部署方式",
  "shell.operator": "服务运营方",
  "shell.operatorUnknown": "实例运营方尚未设置",
  "shell.productCredit": "Sentori 由 GOLIA 开发，此实例由上方的服务运营方负责运行。",

  "bench.projectSwitcher": "工作区项目",
  "filters.advanced": "高级筛选",
  "bench.title": "工作台",
  "bench.explorer": "资源",
  "bench.inspector": "检查器",
  "bench.activity": "动态",
  "bench.toggleExplorer": "切换资源面板",
  "bench.toggleInspector": "切换检查器",
  "bench.toggleActivity": "切换底部面板",
  "bench.reset": "重置工作台布局",
  "bench.resize": "调整{name}尺寸",
  "bench.tabs": "调查标签",
  "bench.tabHint": "方向键切换标签，Alt + 方向键调整顺序",
  "bench.closeTab": "关闭{name}",
  "bench.moved": "{name}已移至第{position}项，共{total}项",
  "bench.recent": "最近{count}条，共{total}条",
  "bench.empty": "暂无记录",
  "bench.loadFailed": "资源加载失败",
  "bench.selectIssue": "选择问题以查看处理动态",
  "bench.context": "当前上下文",
  "bench.project": "项目",
  "bench.status": "状态",
  "bench.release": "版本",
  "bench.environment": "环境",
  "bench.events": "事件",
  "bench.platform": "平台",
  "bench.issues": "问题",
  "bench.releases": "版本",
  "inspect.event": "当前事件",
  "inspect.frame": "选中栈帧",
  "inspect.frameNumber": "第 {n} 帧",
  "inspect.function": "函数",
  "inspect.location": "源码位置",
  "inspect.sourceAvailable": "展开该栈帧可查看源码上下文",
  "inspect.selectFrame": "选择栈帧，查看完整位置与源码状态",
  "inspect.eventContext": "事件上下文",
  "inspect.backToEvent": "返回事件",
  "inspect.identifiers": "标识与地址",
  "inspect.imageBase": "映像基址",
  "bench.selection": "打开资源以查看详细上下文",
  "bench.unknown": "未提供",

  "queue.shortcutButton": "快捷键",
  "queue.shortcutMove": "切换问题",
  "queue.shortcutOpen": "打开问题",
  "queue.shortcutSelect": "选择问题",
  "crashFree.emptyHint": "收到客户端会话后显示统计",
  "apps.unidentified": "未识别应用 · {platform}",
  "apps.unidentifiedData": "未识别数据",
  "apps.unidentifiedHint": "这些事件缺少明确的应用身份，不计入应用数量",
  "apps.events24h": "24 小时内 {count} 条事件",
  "apps.inferredName": "根据版本名推断，尚未确认",
  "apps.nameSource": "名称来源",
  "apps.identifier": "应用标识",
  "apps.sourceConfigured": "由项目所有者设置",
  "apps.sourceReported": "客户端上报的应用标识",
  "apps.sourceRelease": "根据版本名推断",
  "apps.sourceUnknown": "尚未识别应用身份",
  'apps.title': "应用",
  'apps.all': "全部应用",
  'apps.loadFailed': "无法加载应用",
  'apps.platforms': "已识别的平台与接入指南",
  'apps.filesOnly': "已上传文件",
  'apps.empty': "收到数据后会自动识别应用，点击上方平台查看接入指南",
  'apps.edit': "编辑应用",
  'apps.create': '添加 App',
  'apps.identifierHint': '填写 SDK 实际上报的标识（Bundle ID、包名或配置的 App identifier）。',
  'apps.kind': '应用类型',
  'apps.name': "应用名称",
  'apps.repository': "Git 仓库",
  'apps.repositoryHint': "此应用的仓库地址",
  'apps.conflict': "此应用已被修改，请关闭弹窗、刷新后重试",

  "instanceHealth.title": "实例健康检查",
  "instanceHealth.hint": "只读检查，不写入测试数据或连接外部服务。备份记录不代表异地备份可用或恢复演练成功",
  "instanceHealth.run": "检查实例健康",
  "instanceHealth.unknownCheck": "其他检查",
  "instanceHealth.unknownReason": "当前界面无法解释此结果，请核对服务端与界面版本",
  "instanceHealth.status.pass": "正常",
  "instanceHealth.status.warning": "需要处理",
  "instanceHealth.status.fail": "失败",
  "instanceHealth.status.unknown": "无法确认",
  "instanceHealth.check.database": "数据库连接",
  "instanceHealth.check.schema": "数据库结构",
  "instanceHealth.check.instance": "实例身份与状态",
  "instanceHealth.check.backup": "最近备份记录",
  "instanceHealth.check.operations": "实例运维任务",
  "instanceHealth.check.storage": "持久存储目录",
  "instanceHealth.check.recovery": "灾难恢复能力",
  "instanceHealth.reason.database_reachable": "数据库查询成功",
  "instanceHealth.reason.database_unavailable": "数据库未响应，请检查连接、服务与凭据",
  "instanceHealth.reason.metadata_unavailable": "无法读取诊断信息，请检查数据库版本与权限",
  "instanceHealth.reason.schema_matches_binary": "迁移版本和摘要与当前程序一致",
  "instanceHealth.reason.schema_mismatch": "迁移与当前程序不一致，请核对升级或回退版本",
  "instanceHealth.reason.instance_ready": "实例已初始化且处于正常运行模式",
  "instanceHealth.reason.recovery_validation_active": "处于恢复校验模式，验证数据后再恢复后台任务",
  "instanceHealth.reason.setup_incomplete": "请完成实例初始化",
  "instanceHealth.reason.instance_identity_invalid": "实例身份或运行模式不符合单主体约束",
  "instanceHealth.reason.recent_backup_record": "24 小时内有备份完成记录；本次未读取备份文件",
  "instanceHealth.reason.backup_record_stale": "最近备份已超过 24 小时，请检查备份安排",
  "instanceHealth.reason.backup_clock_invalid": "备份时间异常，请核对服务器时钟",
  "instanceHealth.reason.backup_record_missing": "当前实例代次没有备份完成记录，请创建并保存独立备份",
  "instanceHealth.reason.lifecycle_operation_stalled": "有排队过久或租约过期的任务，请检查操作记录和服务日志",
  "instanceHealth.reason.no_stalled_lifecycle_operations": "未发现排队过久或租约过期的实例运维任务",
  "instanceHealth.reason.storage_not_persistent": "未配置持久文件存储，重启可能丢失附件",
  "instanceHealth.reason.storage_directory_readable": "存储目录可读取；未测试写入、剩余空间或所有文件完整性",
  "instanceHealth.reason.storage_directory_unreadable": "无法读取存储目录，请检查挂载与权限",
  "instanceHealth.reason.recovery_not_verified": "未验证异地副本、恢复密钥和实际恢复；请独立校验备份并在隔离实例演练",

  "cloud.renameWorkspace": "修改工作空间名称",
  "cloud.renameOrganization": "修改组织名称",
  "cloud.orgOwner": "组织所有者",
  "cloud.orgMember": "组织成员",
  "cloud.makeOwner": "设为所有者",
  "cloud.makeMember": "设为成员",
  "cloud.removeMember": "移除成员",
  "cloud.memberChangeHint": "修改 {email} 的权限。组织所有者可以管理所有工作空间及账单。移除成员会立即撤销其工作空间访问权限。",
  "cloud.provisioningFailed": "工作空间开通失败。重试会继续使用已有资源。",
  "cloud.provisioningWait": "付款已确认，正在等待工作空间开通。以这里的实际状态为准。",
  "cloud.quote": "套餐报价",
  "cloud.plan": "套餐",
  "cloud.month": "月",
  "cloud.year": "年",
  "cloud.requestQuote": "生成报价",
  "cloud.billing": "订阅与账单",
  "cloud.checkoutUnavailable": "购买尚未开放",
  "cloud.internalWorkspace": "内部工作区，由运营方提供服务",
  "cloud.trialWorkspace": "试用工作区",
  "cloud.testBilling": "当前为测试支付环境，不代表正式服务已上线",
  "cloud.paymentStatus": "支付状态",
  "cloud.paidUntil": "已付服务期限至 {time}",
  "cloud.continueCheckout": "继续到支付页",
  "cloud.retryVerification": "重新核对支付",
  "cloud.renewalCancelled": "本期结束后不再自动续费",
  "cloud.renewalActive": "自动续费已开启",
  "cloud.resumeRenewal": "恢复自动续费",
  "cloud.cancelRenewal": "取消自动续费",
  "cloud.invoices": "已付账单",
  "cloud.workspaceMembers": "工作空间授权",
  "cloud.workspaceMembersHint": "组织 owner 自动拥有工作空间管理权限。普通成员需单独授权；项目成员登录后，还需在工作空间中分配项目。",
  "cloud.revokeAccess": "撤销访问权限",
  "cloud.selectMember": "选择组织成员",
  "cloud.grantAccess": "保存访问权限",
  "cloud.renewalHint": "操作提交后由支付服务执行并核对结果。取消续费保留当前已付期限，页面不会提前显示成功。",
  "cloud.quoteExpires": "报价接受期限至 {time}",
  "cloud.serviceTerms": "服务条款",
  "cloud.privacy": "隐私条款",
  "cloud.refunds": "退款条款",
  "cloud.agreeTerms": "我已阅读并接受上述条款（版本 {revision}）",
  "cloud.acceptQuote": "接受报价并准备结账",
  "cloud.taxIncluded": "含税",
  "cloud.taxExtra": "税费在支付页计算",

  "cloud.signIn": "登录 Sentori Cloud",
  "cloud.register": "注册 Cloud 账户",
  "cloud.verify": "验证账户",
  "cloud.linkSent": "若该邮箱符合条件，验证邮件已进入发送队列。请查收邮件。",
  "cloud.emailFirst": "先验证邮箱，再设置密码",
  "cloud.displayName": "显示名称",
  "cloud.mailUnavailable": "邮件服务尚未配置，请稍后再试",
  "cloud.actionFailed": "操作未能完成，请查看原因并重试",
  "cloud.sendLink": "发送验证邮件",
  "cloud.accessInvalid": "登录请求无效，请从工作空间重新发起登录",
  "cloud.enter": "进入工作空间",
  "cloud.console": "Cloud 控制台",
  "cloud.signOut": "退出 Cloud",
  "cloud.organizations": "组织",
  "cloud.passwordSessions": "修改密码将退出所有 Cloud 会话及其工作空间登录，请重新登录",
  "cloud.invitations": "待接受邀请",
  "cloud.acceptInvitation": "接受邀请",
  "cloud.previous": "上一页",
  "cloud.next": "下一页",
  "cloud.organizationName": "组织名称",
  "cloud.createOrganization": "创建组织",
  "cloud.workspaces": "工作空间",
  "cloud.manageWorkspace": "管理工作空间",
  "cloud.workspaceName": "工作空间名称",
  "cloud.region": "数据地区",
  "cloud.createWorkspace": "创建工作空间草稿",
  "cloud.catalogUnavailable": "运营方尚未配置可用地区与套餐",
  "cloud.members": "组织成员",
  "cloud.inviteHint": "邀请会出现在收件人的 Cloud 控制台中，目前不发送邀请邮件",
  "cloud.invite": "邀请成员",
  "cloud.revokeInvitation": "撤销邀请",
  "cloud.state.draft": "草稿",
  "cloud.state.checkout": "等待结账",
  "cloud.state.paid": "已付款，等待开通",
  "cloud.state.provisioning": "开通中",
  "cloud.state.ready": "可用",
  "cloud.state.suspended": "已暂停",
  "cloud.state.closed": "已关闭",

  "cloud.workspace": "Cloud 工作空间",
  "cloud.usage": "工作空间用量",
  "cloud.usageFailed": "无法加载工作空间用量",
  "cloud.events": "本月事件",
  "cloud.replays": "本月回放",
  "cloud.ingestBytes": "本月接收字节",
  "cloud.artifactBytes": "源码制品存储字节",
  "cloud.resetAt": "月用量于 {time} 重置（按 UTC 自然月）",
  "cloud.unavailable": "当前接收授权不可用",
  "cloud.retention": "事件保留 {events} 天 · 回放保留 {replays} 天 · 每秒最多 {rate} 个事件",
  "cloud.trafficHint": "流量按规范化 JSON 和上传文件内容计量，包含获准接收的重试。删除数据不返还月用量。",

  "auth.modeFailed": "无法加载登录方式",
  "auth.cloudTitle": "Sentori Cloud",
  "auth.cloudHint": "请使用已获此工作空间授权的 Cloud 账户登录",
  "auth.cloudManaged": "密码和组织成员资格由 Sentori Cloud 管理",
  "auth.cloudAccount": "管理 Cloud 账户",
  "auth.cloudSignIn": "使用 Cloud 账户登录",
  "auth.cloudMembers": "请在 Sentori Cloud 管理成员。成员首次登录此工作空间后，可在这里分配项目。",

  "lifecycle.database": "数据库",
  "lifecycle.files": "回放与源码文件",
  "lifecycle.upload": "上传并校验",
  "lifecycle.verify": "校验备份",
  "lifecycle.uploadedArchive": "上传的备份",
  "lifecycle.instanceBackup": "实例备份",
  "lifecycle.sourceInstance": "源实例",
  "lifecycle.archiveFile": "加密备份文件",
  "lifecycle.keyFile": "恢复密钥文件",
  "lifecycle.invalidKey": "请选择为此备份保存的恢复密钥文件，内容应为 64 位十六进制字符",
  "lifecycle.uploadHint": "上传加密恢复包及对应密钥进行独立校验。此操作只检查文件，不恢复数据。浏览器上传支持最大 1 GiB，更大文件请使用 operator CLI。",
  "lifecycle.uploadTooLarge": "此备份超过 1 GiB，请使用 operator CLI 校验",

  "reset.title": "重置实例",
  "reset.hint": "生成并验证最新备份后清空实例数据，重新初始化",
  "reset.consequences": "重置会删除项目、事件、回放文件、成员、会话、凭据和待执行任务。实例 ID 和名称保留，代次递增。离线工具会先生成并验证完整加密备份。已有的加密备份文件与部署配置仍由操作员管理。",
  "reset.typeName": "输入实例名称",
  "reset.typeId": "输入实例 ID",
  "reset.typeGeneration": "输入实例代次",
  "reset.password": "当前所有者密码",
  "reset.acknowledge": "我理解重置会清空此实例，并会将备份和操作日志放在独立存储上，另行保管恢复密钥。",
  "reset.prepare": "准备离线重置",
  "reset.wrongPassword": "当前密码不正确，请重新输入",
  "reset.failed": "未能确认重置许可，请刷新实例后重新准备。新许可会替换上一次许可。",
  "reset.prepared": "已授权离线执行重置，尚未清空任何数据",
  "reset.expires": "许可到期时间",
  "reset.downloadPermit": "下载重置许可",
  "reset.storageStep": "下载许可，将独立恢复存储挂载到 /recovery，并在 /keys/recovery.key 单独保管恢复密钥。示例路径必须与操作环境一致。",
  "reset.stopStep": "停止此数据库的所有服务副本及其他运维命令，保持 PostgreSQL 运行。",
  "reset.executeStep": "配置此实例的数据库连接和主密钥后执行下方命令。工具会生成最新备份、读回校验并保存操作日志，然后才清空数据。",
  "reset.restartStep": "仅在命令成功后重启服务。配置重新初始化所用的所有者，检查环境，再次初始化实例。",
  "reset.interrupted": "若清空数据库后的文件清理中断，服务会拒绝启动。请保留备份、密钥和操作日志，用下方命令继续清理，不要手动移除待完成状态。",
  "lifecycle.title": "自部署",
  "lifecycle.description": "管理此实例、加密备份与恢复",
  "lifecycle.overview": "概览",
  "lifecycle.setup": "配置",
  "lifecycle.backups": "备份",
  "lifecycle.activity": "操作记录",
  "lifecycle.ownerOnly": "仅实例所有者可以创建和下载备份",
  "lifecycle.latestBackup": "最近已校验的备份",
  "lifecycle.noBackup": "暂无可用备份",
  "lifecycle.generation": "代次",
  "lifecycle.recovery": "恢复",
  "lifecycle.offInstance": "将备份下载到独立存储。同机备份无法防范整机丢失；请另行保管恢复密钥和实例主密钥。",
  "lifecycle.recoveryHint": "停用目标服务后，恢复到空数据库和新的文件目录。启动恢复后的实例，先校验回放与源码映射，确认旧实例已停用后，再明确恢复后台运行。",
  "lifecycle.runbook": "查看部署与恢复指南",
  "lifecycle.create": "创建备份",
  "lifecycle.backupHint": "对数据库及其引用的回放、源码文件创建一致性快照，用恢复密钥加密，并在开放下载前校验实际写入的文件。",
  "lifecycle.encrypted": "加密恢复包",
  "lifecycle.configureHint": "在服务器配置持久化文件存储、SENTORI_MASTER_KEY 和绝对路径 SENTORI_BACKUP_DIR 后即可启用备份。",
  "lifecycle.rows": "行",
  "lifecycle.cancelling": "正在取消",
  "lifecycle.verifying": "正在校验备份",
  "lifecycle.state.queued": "排队中",
  "lifecycle.state.running": "正在备份",
  "lifecycle.state.ready": "已校验",
  "lifecycle.state.failed": "失败",
  "lifecycle.state.cancelled": "已取消",
  "lifecycle.state.unavailable": "文件不可用",
  "lifecycle.reason.cancelled": "操作在完成前已取消",
  "lifecycle.reason.instance_changed": "实例已变化，请为当前实例重新发起操作",
  "lifecycle.reason.instance_restored": "此记录来自恢复前的实例，请从原存储位置获取归档",
  "lifecycle.reason.key_unavailable": "无法解密保存的恢复密钥，请检查实例主密钥",
  "lifecycle.reason.capture_failed": "备份失败，请检查服务器存储和日志后重新创建",
  "lifecycle.reason.verification_failed": "校验失败，请检查恢复密钥、归档完整性和运维工具版本",
  "lifecycle.reason.retry_exhausted": "任务已达到重试上限，请检查服务器日志后重新发起操作",
  "lifecycle.operationFailed": "此次操作没有生成可下载的备份",
  "lifecycle.download": "下载备份",
  "lifecycle.verifyHint": "使用与备份相同版本的 CLI。将 DATABASE_URL 指向空的目标数据库，并单独配置原 SENTORI_MASTER_KEY，备份中不包含该主密钥。仅校验文件时只需要备份和恢复密钥。",
  "lifecycle.auditHint": "创建、取消、校验完成和下载开始均记录在实例审计日志中。开始下载不代表备份已安全保存到实例之外。",
  "lifecycle.openAudit": "查看审计日志",
  "lifecycle.keyHint": "创建备份前先保存本次生成的恢复密钥。解密必须使用它，备份历史中无法重新获取。服务器仅在任务期间加密暂存，完成后清除。",
  "lifecycle.saveKey": "下载恢复密钥",
  "lifecycle.savedKey": "我已将恢复密钥保存到安全位置",
  "lifecycle.uncertain": "尚未确认请求结果。重试会使用同一指令，避免创建重复备份。",

  "pushOps.stoppedKinds": "含失败、结果不确定或已取消",
  "pushOps.deviceSearch": "搜索设备 ID、令牌尾部或应用版本",
  "pushOps.setupOnly": "设置检查反映凭据和设备配置，实际投递结果以发送记录为准",
  "pushOps.setupReady": "未发现设置问题",

  "pushOps.description": "预览收件设备、发送通知，并查看真实投递结果",
  "pushOps.accepted24h": "24 小时服务商接受",
  "pushOps.liveDevices": "活跃设备",
  "pushOps.search": "搜索通知标题或正文",
  "pushOps.provider": "服务商",
  "pushOps.allProviders": "全部服务商",
  "pushOps.retryVisible": "重试本页失败记录",
  "pushOps.status": "状态",
  "pushOps.retries": "重试次数",
  "pushOps.created": "创建时间",
  "pushOps.details": "详情",
  "pushOps.noSends": "没有符合筛选条件的通知",
  "pushOps.confirmSend": "确认发送",
  "pushOps.review": "预览通知",
  "pushOps.queuedResult": "通知已加入队列，请在投递记录中查看结果",
  "pushOps.reviewDevice": "通知将发送到下列设备",
  "pushOps.chooseDevice": "选择已注册的设备",
  "pushOps.credential": "凭据",
  "pushOps.accepted": "服务商接受",
  "pushOps.receipt": "SDK 回执",
  "pushOps.noReceipt": "尚未收到 SDK 回执",
  "pushOps.attempts": "最近的发送尝试",
  "pushOps.noAttempts": "尚无工作进程发送记录",
  "pushOps.duplicateAck": "服务商可能已接受此通知，我知晓重试可能导致重复发送",
  "pushOps.confirmRetry": "确认重试",
  "pushOps.bulkHint": "将重试以下 {count} 条失败通知，请先核对列表",
  "pushOps.deviceScope": "设备范围",
  "pushOps.allDevices": "全部设备，含已撤销",
  "pushOps.revoked": "已撤销",
  "pushOps.live": "活跃",
  "pushOps.addressable": "已识别用户",
  "pushOps.yes": "是",
  "pushOps.no": "否",
  "pushOps.lastSeen": "最后活跃",
  "pushOps.confirmRevoke": "确认撤销",
  "pushOps.revoke": "撤销设备",
  "pushOps.badStreak": "连续失败次数",
  "pushOps.revokeHint": "此注册设备将停止接收通知，尚未开始发送的通知会被取消",
  "pushOps.stagedHint": "新凭据先保存为待启用状态，验证后可手动切换",
  "pushOps.vaultMissing": "请先配置实例加密密钥，再添加服务商凭据",
  "pushOps.active": "已启用",
  "pushOps.staged": "待启用",
  "pushOps.verification": "最近验证",
  "pushOps.unverified": "未验证",
  "pushOps.fileTooLarge": "请选择不超过 64 KiB 的凭据文件",
  "pushOps.saveStaged": "保存待启用凭据",
  "pushOps.uploadCredential": "凭据文件",
  "pushOps.probe": "向服务商验证",
  "pushOps.activate": "启用凭据",
  "pushOps.encrypted": "已加密存储",
  "pushOps.legacy": "旧凭据等待加密",
  "pushOps.forceAck": "此凭据尚未通过验证，我知晓启用可能导致投递失败",
  "pushOps.deleteHint": "删除此凭据可能使排队中的通知无法发送，请核对上方凭据",
  "pushOps.confirmDelete": "确认删除",
  "pushOps.join": "条件匹配方式",
  "pushOps.source": "条件来源",
  "pushOps.key": "字段名",
  "pushOps.operator": "比较方式",
  "pushOps.value": "值",
  "pushOps.addCondition": "添加条件",
  "pushOps.preview": "预览受众",
  "pushOps.matched": "台匹配设备",
  "pushOps.previewExpires": "预览有效期至",
  "pushOps.traits": "属性",
  "pushOps.state.queued": "排队中",
  "pushOps.state.sending": "发送中",
  "pushOps.state.sent": "服务商已接受",
  "pushOps.state.acknowledged": "SDK 已回执",
  "pushOps.state.failed": "失败",
  "pushOps.state.uncertain": "结果不确定",
  "pushOps.state.cancelled": "已取消",
  "pushOps.verdict.ok": "验证通过",
  "pushOps.verdict.rejected": "被拒绝",
  "pushOps.verdict.malformed": "格式无效",
  "pushOps.verdict.unreachable": "服务商不可达",
  "pushOps.verdict.limited": "权限受限",
  "pushOps.verdict.not_implemented": "暂不支持验证",

  "monitor.finalStatusHint": "跟随重定向后的最终状态码：200–299 或 400–599",
  "integration.title": "集成",
  "integration.description": "配置通知渠道，查看实际投递结果",
  "integration.configuredHint": "“已配置”表示设置已保存，是否成功送达请查看投递记录",
  "integration.email": "邮件",
  "integration.unconfigured": "未配置",
  "integration.configured": "已配置",
  "integration.hint.email": "通过此实例已配置的 SMTP 服务发送",
  "integration.hint.webhook": "发送带签名和固定投递 ID 的 JSON 通知",
  "integration.hint.github": "使用有 issue 写入权限的令牌在指定仓库创建 issue",
  "integration.hint.jira": "通过 Jira Cloud v3 API 创建工作项",
  "integration.destination": "目标",
  "integration.smtpMissing": "此实例尚未配置 SMTP",
  "integration.configure": "配置",
  "integration.sendTest": "发送测试",
  "integration.confirmSend": "确认发送",
  "integration.exportTask": "复制到外部任务系统",
  "integration.exportHint": "将任务标题和描述复制为外部工作项，Sentori 任务状态保持不变",
  "integration.createsTicket": "这会在已配置的外部项目中创建真实工作项",
  "integration.realSend": "这会向已配置的目标发送真实通知",
  "integration.queueHint": "请求进入持久队列，服务方的响应会记录在投递日志中",
  "integration.queuedHint": "已加入队列。请刷新投递日志查看结果。",
  "integration.token": "凭据 / 签名密钥",
  "integration.recipient": "收件邮箱",
  "integration.jiraEndpoint": "Jira 站点 URL",
  "integration.accountEmail": "Jira 账号邮箱",
  "integration.projectKey": "Jira 项目键",
  "integration.issueType": "Jira 工作项类型 ID",
  "integration.secretHint": "加密保存。新的 HTTP 集成必须使用 HTTPS。",
  "integration.keepSecret": "留空保留原值。更换目标地址时需重新填写凭据。",
  "integration.events": "自动通知",
  "integration.autoSend": "选中的事件会自动发送通知，默认不选中任何事件",
  "integration.autoTickets": "每次选中的事件都会创建新的外部工作项。全部不选时仅在手动操作后复制。",
  "integration.event.issueNew": "新问题",
  "integration.event.issueRegressed": "问题回归",
  "integration.event.taskAssigned": "任务指派",
  "integration.event.taskUpdated": "任务更新",
  "integration.deliveries": "投递日志",
  "integration.noDeliveries": "暂无投递记录",
  "integration.state.queued": "排队中",
  "integration.state.running": "发送中",
  "integration.state.retryWait": "等待重试",
  "integration.state.delivered": "已送达",
  "integration.state.failed": "失败",
  "integration.state.uncertain": "结果待确认",
  "integration.state.cancelled": "已取消",
  "integration.attempt": "尝试次数：{count} / 5",
  "integration.openExternal": "打开外部工作项",
  "integration.retry": "重试投递",
  "integration.uncertainHint": "连接或 worker 中断前，目标可能已经接收了请求。请先在目标系统核对，再决定是否重试。",
  "integration.retryHint": "使用相同投递 ID 重试，并重新检查当前配置及访问权限",
  "integration.duplicateAck": "我已核对目标系统，并接受重试可能产生重复记录",

  "monitor.title": "服务状态",
  "monitor.description": "定时检查、故障记录与恢复通知",
  "monitor.publicOnly": "仅检查 80 或 443 端口的公网 HTTP/HTTPS 地址，不接受内网地址及 URL 用户凭据。",
  "monitor.create": "新建监控",
  "monitor.edit": "编辑监控",
  "monitor.empty": "此项目暂无监控",
  "monitor.unknown": "尚未检查",
  "monitor.operational": "正常",
  "monitor.degraded": "检查失败",
  "monitor.down": "故障中",
  "monitor.paused": "已暂停",
  "monitor.availability": "可用率 · 30 天",
  "monitor.latency": "响应耗时",
  "monitor.lastCheck": "最近检查",
  "monitor.samples": "最近检查记录",
  "monitor.window": "当前配置最近 30 天共 {count} 次检查",
  "monitor.incident": "连续失败已达到设定阈值。检查成功后将关闭此次故障。",
  "monitor.failureThreshold": "连续失败阈值",
  "monitor.checkNow": "立即检查",
  "monitor.noHistory": "暂无记录",
  "monitor.incidents": "故障历史",
  "monitor.recovered": "已恢复",
  "monitor.name": "监控名称",
  "monitor.url": "健康检查 URL",
  "monitor.intervalSeconds": "间隔（分钟）",
  "monitor.timeoutSeconds": "超时（秒）",
  "monitor.expectedStatus": "预期 HTTP 状态码",
  "monitor.editHint": "保存后开启新的统计周期，并取消旧配置尚未完成的检查结果。故障历史会保留。",
  "monitor.deleteHint": "删除此监控并停止后续检查？既有故障记录仍会保留。",
  "monitor.confirmDelete": "删除监控",

  "team.autoWork": "开始了修复",
  "team.autoPrOpened": "发起了合并请求",
  "team.autoPrMerged": "合并了修复",
  "team.autoChecks": "收到了 CI 结果",
  "team.autoDeployment": "收到了部署结果",
  "team.commit": "提交",
  "team.pullRequest": "合并请求",
  "team.unitChecks": "单元测试",
  "team.e2eChecks": "端到端测试",
  "team.deployedRelease": "已部署版本",
  "team.passed": "通过",
  "team.checkFailed": "失败",

  "team.markAllRead": "全部标为已读",
  "team.formerAssignee": "原项目成员",
  "team.issueTask": "查看关联任务",

  "team.automation": "任务自动化",
  "team.integrationHint": "通过签名事件接入 CI 和部署系统。仓库、提交和环境匹配后，任务才能获得验证。",
  "team.vaultRequired": "在服务端设置 SENTORI_MASTER_KEY，以启用加密保存的集成凭据。",
  "team.repository": "仓库",
  "team.environment": "部署环境",
  "team.enabled": "启用",
  "team.rotate": "更换签名密钥，旧密钥将失效",
  "team.signingKey": "签名密钥",
  "team.secretOnce": "仅在此时显示，请保存到 CI 的密钥存储中",
  "team.endpoint": "Webhook 地址",
  "team.signatureHelp": "发送 X-Sentori-Timestamp（Unix 秒）和 X-Sentori-Signature: sha256=<使用签名密钥，对时间戳 + \".\" + 原始 JSON 计算 HMAC-SHA256>。时间戳须在五分钟内。",

  "team.save": "保存",
  "team.cancel": "取消",
  "team.search": "搜索任务",

  "team.title": "任务",
  "team.description": "跟进任务的分类、修复、评审与验证",
  "team.create": "新建任务",
  "team.edit": "编辑任务",
  "team.taskTitle": "标题",
  "team.details": "描述",
  "team.kind": "类型",
  "team.task": "任务",
  "team.bug": "缺陷",
  "team.priority": "优先级",
  "team.urgent": "紧急",
  "team.high": "高",
  "team.normal": "普通",
  "team.low": "低",
  "team.assignee": "负责人",
  "team.unassigned": "未分配",
  "team.everyone": "所有人",
  "team.mine": "分配给我",
  "team.stage": "阶段",
  "team.triage": "待分类",
  "team.ready": "待开始",
  "team.inProgress": "进行中",
  "team.review": "评审中",
  "team.verify": "验证中",
  "team.done": "已完成",
  "team.cancelled": "已取消",
  "team.due": "截止日期",
  "team.reproduction": "复现步骤",
  "team.rootCause": "根因",
  "team.view": "视图",
  "team.list": "列表",
  "team.board": "看板",
  "team.all": "全部",
  "team.refresh": "刷新",
  "team.pageHint": "共 {count} 个任务 · 每页最多显示 50 个任务",
  "team.empty": "没有符合条件的任务",
  "team.failed": "协作数据操作失败",
  "team.chooseProject": "选择有权限的项目以查看任务",
  "team.uncertain": "未收到结果。请重试已保存的请求以确认结果。",
  "team.conflict": "草稿已保留。如果任务已变更，请关闭编辑框、刷新任务后编辑最新版本。",
  "team.issue": "关联问题",
  "team.manual": "手动变更阶段",
  "team.manualHint": "手动完成会解决关联问题并记录操作，不代表 CI 或部署验证通过",
  "team.evidence": "验证证据",
  "team.verified": "同一提交已验证并部署",
  "team.noEvidence": "尚无完整的构建验证和部署证据",
  "team.activity": "活动记录",
  "team.system": "系统",
  "team.created": "创建了任务",
  "team.updated": "更新了任务",
  "team.stageChanged": "变更了阶段",
  "team.commented": "添加了评论",
  "team.regressed": "因问题回归而重新打开",
  "team.comment": "评论",
  "team.mention": "提及",
  "team.noMention": "不提及",
  "team.post": "发表评论",
  "team.inbox": "个人收件箱",
  "team.inboxDescription": "查看有权限项目中的分配、提及和任务更新",
  "team.preferences": "通知偏好",
  "team.unread": "未读",
  "team.archived": "已归档",
  "team.inboxCount": "{count} 条未读通知",
  "team.inboxEmpty": "此视图暂无通知",
  "team.assignment": "分配",
  "team.taskUpdates": "任务更新",
  "team.monitors": "监控通知",
  "team.markRead": "标为已读",
  "team.markUnread": "标为未读",
  "team.archive": "归档",
  "team.restore": "移回收件箱",

  "jobs.title": "重新解析已有事件",
  "jobs.hint": "使用当前可用的调试文件，检查任务开始前最新的 20,000 条错误事件。问题分组保持不变。",
  "jobs.run": "开始重新解析",
  "jobs.refresh": "刷新任务",
  "jobs.queued": "排队中",
  "jobs.running": "运行中",
  "jobs.retryWait": "等待重试",
  "jobs.succeeded": "已完成",
  "jobs.failed": "失败",
  "jobs.cancelled": "已取消",
  "jobs.actionFailed": "无法更新后台任务",
  "jobs.empty": "暂无重新解析任务",
  "jobs.progress": "已检查 {scanned} · 已更新 {rewritten} · 已恢复栈帧 {frames}",
  "jobs.attempt": "第 {attempt} 次尝试，最多 {max} 次",
  "jobs.limit": "本次已达到 20,000 条事件上限",
  "jobs.cancel": "取消任务",
  "jobs.cancelling": "已请求取消",
  "jobs.processingFailed": "处理失败，请查看服务端日志了解详情",
  "jobs.timeout": "一批事件处理超时",
  "jobs.exhausted": "已达到重试次数上限",
  "jobs.generationChanged": "实例已变更，请发起新任务",
  "detail.firstSeen": "首次出现",
  "detail.previousAssignee": "原负责人 · {id}",
  "detail.rawEvent": "原始事件",
  'releaseView.notFound': '此版本在当前项目中不可用',
  "releaseView.description": "检查版本健康度，以及还原可读堆栈所需的文件",
  "releaseView.search": "搜索版本",
  "releaseView.sessions": "会话",
  "releaseView.artifacts": "调试文件",
  "releaseView.created": "创建时间",
  "releaseView.healthFailed": "无法加载版本健康数据",
  "releaseView.artifactFailed": "无法加载调试文件",
  "releaseView.window": "最近 30 天",
  "releaseView.usable": "格式已验证",
  "releaseView.unusable": "格式无效",
  "releaseView.unchecked": "尚未验证",
  "releaseView.upload": "上传调试文件",
  "releaseView.file": "文件",
  "releaseView.fileHint": "支持 gzip 压缩；上传大小须小于 256 MiB。请使用对应构建的文件。",
  "releaseView.actionFailed": "上传失败；已选文件保留，可重试",
  "releaseView.uploaded": "文件已存储，格式验证通过。已有事件将在后台重新处理，构建匹配按具体事件判断。",
  "releaseView.uploadedInvalid": "文件已保存，但无法用于符号化。请检查文件类型和构建版本。",
  "releaseView.deleteHint": "将删除此版本及其全部调试文件，已收到的事件保留",
  "replay.stepBack": "上一帧",
  "replay.stepForward": "下一帧",
  "replay.speed": "播放速度",
  "detail.assignee": "负责人",
  "detail.unassigned": "未分配",
  "detail.lastReceived": "最近收到",
  "detail.evidence": "现场证据",
  "detail.activity": "活动记录",
  "detail.event": "事件记录",
  "detail.selectEvent": "选择事件",
  "detail.eventsFailed": "无法加载事件记录",
  "detail.eventFailed": "无法加载此事件",
  "detail.foreignEvent": "此事件不属于当前问题",
  "detail.contextFailed": "无法加载关联事件",
  "detail.noEvents": "此问题暂无保留的事件",
  "detail.addNote": "添加备注",
  "detail.note": "备注",
  "detail.saveNote": "保存备注",
  "detail.activityLimit": "最近 100 条活动记录",
  "detail.system": "系统",
  "detail.noActivity": "暂无活动记录",
  "detail.activity.note": "备注",
  "detail.activity.assign": "分配",
  "detail.activity.status": "状态变更",
  "detail.activity.regression": "复发",
  "queue.title": "问题",
  "queue.description": "按实际事件筛选和处理问题",
  "queue.partialFailure": "{total} 项操作中有 {failed} 项失败；成功的变更已保存。",
  "queue.events": "事件",
  "queue.filteredTotals": "所有符合筛选条件的问题",
  "queue.latestReleases": "最近出现的版本",
  "queue.all": "全部",
  "queue.search": "搜索问题",
  "queue.status": "状态",
  "queue.kind": "类型",
  "queue.sort": "排序",
  "queue.impact": "影响范围",
  "queue.newest": "最近发生",
  "queue.optionsFailed": "无法加载筛选选项",
  "queue.actionFailed": "部分问题未能更新",
  "queue.selectPage": "选择本页",
  "queue.shortcuts": "键盘快捷键",
  "queue.noMatches": "没有符合条件的问题",
  "queue.select": "选择",
  "queue.selectIssue": "选择 {title}",
  "queue.issue": "问题",
  "queue.users": "用户",
  "queue.usersUnknown": "尚未记录可识别的用户",
  "queue.lastSeen": "最近事件 · 设备时间",
  "queue.pageCount": "{first}–{last} / {total}",
  "queue.previous": "上一页",
  "queue.next": "下一页",
  "queue.noMatchesHint": "清除筛选条件以查看其他问题",
  "setup.stepPending": "未开始",
  "setup.stepCurrent": "当前步骤",
  "setup.stepComplete": "已完成",
  "setup.stepError": "需要处理",
  "setup.stepBlocked": "暂不可用",
  "setup.stepSkipped": "已跳过",
  "setup.optional": "可选",
  "setup.back": "上一步",
  "setup.next": "下一步",
  "setup.installStepHint": "安装当前平台的 SDK 包",
  "setup.configureStepHint": "运行测试前，请配置接收地址和 ingest 密钥",
  "settings.allProjects": "所有项目",
  "settings.manageAccess": "管理权限",
  "settings.memberActionFailed": "无法完成成员操作",
  "settings.description": "管理项目权限、密钥和个人账户",
  "settings.selectProject": "请选择有权访问的项目，以管理其令牌",
  "settings.tokenRotation": "轮换密钥时，请先生成新密钥并更新客户端，再撤销旧密钥",
  "settings.tokensLoadFailed": "无法加载令牌",
  "settings.tokenActionFailed": "无法完成令牌操作",
  "settings.tokenScopeHint": "ingest 密钥用于发送 SDK 事件；api 密钥用于自动化访问此项目。",
  'settings.passwordSessionHint': '保存后会退出其他设备上的登录，当前会话保留',
  'settings.passwordFailed': '无法修改密码，请检查当前密码后重试',
  'projects.conflict': '项目已被修改，请重新读取后再保存',
  'projects.reload': '重新读取项目',
  'projects.description': '查看各项目的接入状态、问题与版本',
  'projects.search': '搜索项目',
  'projects.allPlatforms': '所有平台',
  'projects.edit': '编辑项目',
  'projects.open': '打开问题',
  'projects.healthUnavailable': '暂时无法读取健康数据',
  'projects.connected': '已接入',
  'projects.loading': '正在读取状态',
  'projects.waiting': '等待首条事件',
  'projects.errors24h': '24 小时错误数',
  'projects.warnings24h': '24 小时警告数',
  'projects.users24h': '24 小时活跃用户',
  'projects.latestRelease': '最近版本',
  'projects.lastEvent': '最近事件',
  'projects.noMatches': '没有匹配的项目',
  'projects.filterHint': '调整搜索条件或清除筛选',
  'projects.clearFilters': '清除筛选',
  'projects.actionFailed': '项目操作失败',
  'projects.confirmName': '输入项目名称以确认删除',
  'auth.sendFailed': '无法发送重置请求，请重试',
  "settings.tab.instance": "实例",
  "instance.recoveryValidation": "恢复验证中",
  "instance.recoveryHint": "自动发送、监控、后台任务和保留期清理已暂停。请验证恢复的数据，停止旧实例，再通过运维 CLI 显式恢复此实例的运行。",
  "instance.identity": "实例信息",
  "instance.name": "实例名称",
  "instance.id": "实例 ID",
  "instance.origin": "访问地址",
  "instance.version": "服务端版本",
  "instance.status": "初始化状态",
  "instance.ready": "已初始化",
  "instance.pending": "尚未初始化",
  "instance.environment": "访问地址和所有者账户由部署环境管理",
  "instance.checks": "环境检查",
  "instance.checkHint": "检查数据库连接、文件写入／读取／删除和访问地址配置，不验证外网连通性或备份恢复能力",
  "instance.check.database": "数据库连接",
  "instance.check.blobStorage": "文件写入、读取与删除",
  "instance.check.durableStorage": "已配置文件系统存储",
  "instance.check.originValid": "访问地址配置",
  "instance.unchecked": "尚未检查",
  "instance.passed": "通过",
  "instance.failed": "未通过",
  "instance.lastCheck": "上次检查",
  "instance.runChecks": "检查环境",
  "instance.initialize": "完成初始化",
  "instance.refresh": "重新加载实例",
  "instance.loadFailed": "无法加载实例",
  "instance.actionFailed": "操作未能完成",
  "instance.conflict": "配置已被修改，请重新加载实例后再试",
  "instance.checkRequired": "请重新检查环境后再完成初始化",
  "instance.checked": "检查完成",
  'common.close': '关闭',
  'impact.events': '{count} 次事件',
  'impact.maximum': '单个已识别用户最多 {max} 次',
  'impact.users': '{count} 位用户',
  'nav.setup': '接入应用',
  'setup.alerts': '配置告警通知',
  'setup.appStartup': '应用初始化',
  'setup.askOwner': '请实例所有者创建项目并为你分配权限',
  'setup.check': '检查测试事件',
  'setup.checking': '检查中…',
  'setup.chooseProject': '选择项目',
  'setup.configureTitle': '连接当前项目',
  'setup.copied': '已复制',
  'setup.copy': '复制',
  'setup.copyCode': '复制这段代码',
  'setup.copyFailed': '剪贴板不可用，请选中代码手动复制',
  'setup.createKey': '生成上报密钥',
  'setup.createTitle': '创建应用项目',
  'setup.creating': '创建中…',
  'setup.developmentHint': '示例使用 development 环境。正式接入时请填写实际版本，并与符号文件上传保持一致；可选的视觉回放仍需显式开启。',
  'setup.endpoint': '实例地址',
  'setup.failed': '这一步未能完成',
  'setup.ingestKey': '应用上报密钥',
  'setup.install.android': '按 Kotlin 指南添加对应版本的依赖，并在 AndroidManifest.xml 注册 Application 子类，否则 SDK 不会启动。',
  'setup.install.ios': '在 Xcode 添加 Swift Package 并选择 Sentori 产品。初始化代码放在 App 初始化器或 app delegate 中；测试代码需要导入 Foundation。',
  'setup.install.rn': 'Expo 请使用开发构建；裸 React Native 安装包后还需安装 iOS pods。平台指南包含两种接入方式。',
  'setup.install.weapp': '在微信开发者工具中构建 npm，并在 onLaunch 初始化。测试前先把实例域名加入 request 合法域名。',
  'setup.install.web': '支持现有前端框架。在浏览器入口初始化一次，放在需要监测的业务代码之前。',
  'setup.installTitle': '选择平台并安装',
  'setup.keyHint': '应用中只使用上报密钥，不要放入自动化密钥。新密钥仅显示一次，不保存在浏览器存储中；不再使用时可在设置中吊销。',
  'setup.localEndpoint': '这个地址指向运行应用的设备本身。真机接入时，请换成手机能够访问的实例地址；电脑上的 localhost 不能直接用于手机。',
  'setup.nextHint': '上传对应的 Source Map 或原生符号文件，再验证一次告警。开启回放前，请先检查敏感内容遮罩。',
  'setup.nextTitle': '正式发布前',
  'setup.notChecked': '运行测试后，回到这里检查',
  'setup.openIssue': '查看测试问题',
  'setup.package': '包地址 · 按平台指南安装',
  'setup.platform': '应用平台',
  'setup.platformGuide': '查看完整平台指南',
  'setup.progressHint': '事件到达和源码可读分别验证，生成密钥不代表这两项已经成功',
  'setup.progressTitle': '已经确认的结果',
  'setup.receiptStatus': '本次测试事件已到达',
  'setup.received': '已收到这次测试事件',
  'setup.release': '应用版本',
  'setup.sourceHint': '事件已到达，但尚未确认可读源码位置。请打开问题，检查这个版本的符号文件。',
  'setup.sourceStatus': '已有可读的源码位置',
  'setup.subtitle': '安装 SDK，连接当前项目，再用自己的应用发送测试事件。操作时保留这个页面，随时回来检查结果。',
  'setup.symbolGuide': '符号文件上传指南',
  'setup.terminal': '终端',
  'setup.testAction': '临时测试代码',
  'setup.testHint': '初始化后运行一次，例如放在临时测试按钮里。这会发送一条已捕获错误，不会让应用崩溃。验证完成后请移除测试代码。',
  'setup.title': '接入应用，看清第一条错误',
  'setup.verifyTitle': '从应用发送测试事件',
  'setup.waiting': '暂未收到这次测试事件',
  'setup.waitingHint': '等待几秒后重试；如果仍未收到，请检查实例地址、上报密钥、初始化位置和网络连接。当前项目的其他事件不会被算作本次测试成功。',
  'shell.navigation': '主导航',
  'shell.openNavigation': '打开导航',
  'shell.skip': '跳到内容',
  'site.discover': '第一次了解 Sentori？看看产品能做什么',
  'site.language': '语言',
  'triage.back': '返回问题列表',
  'triage.hideTimeline': '收起事件时间线',
  'triage.showTimeline': '展开事件时间线',
  'auth.backToSignIn': '返回登录',
  'auth.confirm': '确认密码',
  'auth.missingToken': '缺少 token。请从邮件中的链接打开。',
  'auth.newPassword12': '新密码（至少 12 位）',
  'auth.resetDone': '密码已更新——用新密码登录',
  'auth.email': '邮箱',
  'auth.forgot': '忘记密码',
  'auth.forgotHint': '输入邮箱，我们会发送重置链接',
  'auth.password': '密码',
  'auth.passwordTooShort': '密码至少 8 个字符',
  'auth.passwordsDiffer': '两次输入的密码不一致',
  'auth.resetFailed': '重置失败 —— 链接可能已过期',
  'auth.resetPassword': '重置密码',
  'auth.resetSent': '如果该地址存在，重置链接已发出',
  'auth.saving': '保存中…',
  'auth.sendReset': '发送重置链接',
  'auth.sending': '发送中…',
  'auth.setNewPassword': '设置新密码',
  'auth.signIn': '登录',
  'auth.signInFailed': '登录失败。请检查邮箱和密码。',
  'auth.signInTitle': '登录 Sentori',
  'auth.signingIn': '登录中…',

  'common.delete': '删除',
  'common.retry': '重试',
  'inbox.awaitingFirstHint': '这个项目还没收到过任何事件。用 ingest token 把 SDK 指向本实例，issue 会出现在这里。',
  'inbox.emptyNoProject': '创建项目 → 发放 ingest token → 将 SDK 指向本实例。',
  'inbox.group.ignored': '已忽略',
  'inbox.group.open': '未解决',
  'inbox.group.resolved': '已解决',
  'inbox.envFilter': '环境',
  'inbox.releaseFilter': '版本',
  'inbox.groupNew': '新增 · 24h',
  'inbox.groupRegressed': '回归',
  'inbox.loadFailed': '收件箱加载失败',
  'inbox.selectedCount': '已选 {n} 项',

  'health.backend': '后端',
  'health.replay': '录屏',
  'health.silent': '暂无事件',

  'identity.copied': '已复制',
  'identity.copyHint': '复制完整用户标识',

  'instruments.assertRan': '跑了 {total} · 失败 {failed}',
  'instruments.asserts': '断言',
  'instruments.assertsEmpty':
    '还没有生产断言 —— sentori.assert(name, ok) 会建立存活台账。',
  'instruments.guardedIssue': '守护的 issue',
  'instruments.colSamples': '样本',
  'instruments.colPrewarmed': '预热',
  'instruments.launch': '启动',
  'instruments.launchEmpty':
    '还没有启动分段数据 —— 在 app 可用时调用 sentori.launch.complete()（可选 sentori.launch.mark(name) 标记路标），每次启动会聚成一条 app.launch。',
  'instruments.prewarmedTip': '预热进程的幻影样本，不计入分位数',
  'instruments.loadFailed': '监测面板加载失败',
  'instruments.noProject': '还没有项目',
  'instruments.probeFired': '触发 {count} 次 · 最近 {last}',
  'instruments.probeSilent': '自 {since} 起沉默。修复保持中。',
  'instruments.probes': '探针',
  'instruments.probesEmpty':
    '还没有绊线 —— 在修复过的分支里放 sentori.probe(ref)，用 `sentori-cli probes sync` 注册。',
  'instruments.colLastFail': '最近失败',
  'instruments.colLastSeen': '最近出现',
  'instruments.colName': '名称',
  'instruments.colRelease': '版本',
  'instruments.colStatus': '状态',
  'instruments.volume': '{events} 次 · {users} 人',
  'instruments.volumeAnon': '{events} 次 · 用户未知',
  'instruments.colVolume': '量级',
  'instruments.traces': '观察点',
  'instruments.tracesEmpty': '无观察点。sentori.trace(name) 标记代码路径被走到。',

  'issue.code': "调用栈",
  'issue.codeNone': '该事件没有携带调用栈。原生崩溃自带栈；手动上报的 error 要把原始异常对象传给 sentori.error(e)，传字符串就只有一条消息。',
  'issue.eventMoment': '{kind} 触发',
  'issue.notifyAffected': '通知这些人',
  'issue.signals': '用户事件',
  'issue.signalsNone': '该事件没有携带用户行为信号',
  'issue.replayScreensEmpty':
    '该构建开启了像素录屏，但一帧都没抓到 —— 原生二进制比 JS SDK 旧，或者抓帧一直在失败。重新构建原生 app。',
  'issue.replayScreensEmptyTip':
    '该构建要了像素录屏但一帧没拿到 —— 线框回放来自 always-on 结构捕获。',
  'issue.replayWireframeTip':
    '该构建没开 replayScreens —— 线框回放来自 always-on 结构捕获。',
  'issue.guardAnchored': '已在 {release} 解决。只有该版本及更新版本的再现才会重新打开。',
  'issue.guardProbeHint':
    '在修复过的分支里放 sentori.probe(ref) —— 沉默的探针就是修复保持的证明。',
  'issue.guardUnanchored': '解决时未锚定版本。之后任何再现都会重新打开。',
  'issue.ignore': '忽略',
  'issue.deviceClock': '设备时间',
  'issue.loadFailed': '该 issue 加载失败',
  'issue.occurrences': '发生记录',
  'issue.releaseRegressedHere': '在此版本回归',
  'issue.releaseResolvedHere': '在此版本标记修复',
  'issue.releasesTitle': '版本分布',
  'issue.reopen': '重新打开',
  'issue.replayFrom': '{when} 那次发生的录屏。最新事件未携带。',
  'issue.replayNone':
    '该事件没有携带录屏 —— 在 SDK 里开启 replayScreens: true 才会捕获出错前一分钟的画面。',
  'issue.resolve': '解决',
  'issue.resolveInRelease': '修复版本',
  'issue.timeline': '时间轴',
  'nav.inbox': '收件箱',
  'nav.instruments': '监测',
  'nav.projects': '项目',
  'nav.push': '推送',
  'nav.releases': '版本',
  'nav.settings': '设置',

  'notify.saveFailed': '无法保存通知偏好',
  'notify.loadFailed': '通知偏好加载失败',
  'notify.onNewIssue': '新 issue',
  'notify.onRegression': '回归',
  'notify.prefsHint': '按项目控制发给自己的邮件。默认全开。',
  'notify.prefsTitle': '邮件通知条件',
  'notify.webhookTitle': 'Webhook',
  'notify.webhookHint':
    '新 issue 和回归也 POST 到这里，格式是 {"subject", "body", "metadata"}。按项目配，不按人：它发到一个群。完全没有 SMTP 也能用，这正是它存在的理由。',
  'notify.webhookPlaceholder': 'https://hooks.example.com/services/…',
  'notify.webhookSave': '保存',
  'notify.webhookSaved': '已保存',
  'notify.webhookFailed': 'webhook 地址没能保存',
  'notify.webhookOwnerOnly': '只有所有者能看到和修改这一项',
  'notify.smtpTitle': 'SMTP',
  'notify.smtpUnconfigured': 'SMTP 未配置。设置 SENTORI_SMTP_HOST 后生效。',
  'notify.testButton': '发送测试邮件',
  'notify.testFailed': '测试邮件失败。检查 SMTP 配置和服务端日志。',
  'notify.testSending': '发送中…',
  'notify.deliveryFailing': '通知发不出去——最近 7 天失败 {count} 次',
  'notify.lastDelivered': '最后一次送达',
  'notify.testSent': '测试邮件已发出',
  'palette.placeholder': '跳转页面或搜索 issue…',


  'push.section.audience': '受众',
  'push.audienceTitle': '发给谁',
  'push.audienceEditJson': '编辑 JSON',
  'push.audienceEditRows': '回到条件',
  'push.audienceBadJson': '不是合法的 JSON',
  'push.joinAll': '满足全部条件',
  'push.joinAny': '满足任一条件',
  'push.sourceIssue': '遇到过此问题',
  'push.sourceTrait': '用户属性',
  'push.sourceDevice': '设备信息',
  'push.sourceUser': '用户 ID',
  'push.opIs': '等于',
  'push.opIsNot': '不等于',
  'push.opIn': '属于',
  'push.opPrefix': '前缀是',
  'push.opExists': '存在',
  'push.opVersionGte': '版本 ≥',
  'push.opVersionLte': '版本 ≤',
  'push.opGte': '≥',
  'push.opLte': '≤',
  'push.deviceFacts': '设备信息',
  'push.audienceMessage': '发什么',
  'push.confirmSend': '发送给 {n} 台设备？无法撤回。',
  'push.audienceQueued': '已排入 {n} 台设备',
  'push.section.credentials': '凭证',
  'push.section.delivery': '投递',
  'push.section.devices': '设备',
  'push.statusAny': '全部状态',
  'push.testBody': '正文',
  'push.testSend': '发送测试',
  'push.testSubject': '标题',
  'push.testTitle': '发一条测试',
  'push.credentialsAdd': '添加凭证',
  'push.field.keyId': 'Key ID',
  'push.field.production': '环境',
  'push.field.secretKey': '私钥',
  'push.field.subject': '联系方式',
  'push.field.teamId': 'Team ID',
  'push.field.topic': 'Bundle ID',
  'push.field.vapidPublicKey': 'VAPID 公钥',
  'push.hint.apns.keyId': '.p8 文件名里 AuthKey_ 后面那十个字符',
  'push.hint.apns.production': '用开发证书签的构建选沙盒',
  'push.hint.apns.secretKey': '粘贴完整 .p8，保留换行',
  'push.hint.apns.teamId': 'Apple 开发者后台右上角',
  'push.hint.apns.topic': 'app 的 bundle id。发给 Apple 时为 apns-topic。',
  'push.hint.fcm.secretKey': 'Firebase ▸ 项目设置 ▸ 服务账号 ▸ 生成新的私钥',
  'push.hint.webpush.secretKey': 'VAPID 私钥，PEM 格式',
  'push.hint.webpush.subject': '推送服务可联系到你的 mailto: 或 https: 地址',
  'push.hint.webpush.vapidPublicKey': 'base64url。与下方私钥配对。',
  'push.option.production': '生产',
  'push.option.sandbox': '沙盒',
  'push.placeholder.apns.keyId': 'ABC1234567',
  'push.placeholder.apns.secretKey': '-----BEGIN PRIVATE KEY-----\n…\n-----END PRIVATE KEY-----',
  'push.placeholder.apns.teamId': 'DEF7654321',
  'push.placeholder.apns.topic': 'com.example.app',
  'push.placeholder.fcm.secretKey': '{\n  "type": "service_account",\n  "project_id": …\n}',
  'push.placeholder.webpush.secretKey': '-----BEGIN PRIVATE KEY-----\n…\n-----END PRIVATE KEY-----',
  'push.placeholder.webpush.subject': 'mailto:alerts@example.com',
  'push.placeholder.webpush.vapidPublicKey': 'BEl62iUYgUiv…',
  'push.credentialsEmpty':
    '还没有厂商凭证 —— 在上面贴 APNs key 或 FCM service account。没有它设备也能注册，但什么都投递不出去。',
  'push.credentialsTitle': '厂商凭证',
  'push.device': '设备',
  'push.devicesEmpty': '无设备。调用 sentori.push.register() 注册。',
  'push.devicesTitle': '设备',
  'push.failed24h': "24 小时停止发送",
  'push.specHowTo': '获取',
  'push.specApnsTitle': 'iOS · APNs',
  'push.specFcmTitle': 'Android · FCM',
  'push.specWebpushTitle': 'Web · VAPID',
  'push.specApnsStep1': 'Apple Developer → 证书、标识符和描述文件 → 密钥',
  'push.specApnsStep2': '新建密钥，勾选 Apple Push Notifications service (APNs)',
  'push.specApnsStep3': '下载。仅此一次，Apple 不提供第二次下载',
  'push.specFcmStep1': 'Firebase 控制台 → 项目设置 → 服务账号',
  'push.specFcmStep2': '生成新的私钥',
  'push.specFcmStep3': '确认该服务账号具有 Firebase Cloud Messaging API Admin 角色',
  'push.specWebpushStep1': '自行生成 P-256 密钥对',
  'push.specWebpushStep2': '公钥进 app，私钥填在此处',
  'push.specFile': '文件',
  'push.specFirstLine': '首行',
  'push.specSize': '大小',
  'push.specMarker': '标识',
  'push.secretIssue.unrecognised': '既不是 PEM 也不是 JSON',
  'push.credentialLabel': '备注',
  'projects.emptyTitle': '还没有项目',
  'projects.emptyHint': '事件、版本和推送设备都归属于某个项目。在上方起个名字开始。',
  'settings.createProjectFailed': '项目创建失败',
  'push.section.integrate': '接入',
  'push.integrateEndpoint': '端点',
  'push.integrateScopeNote': 'ingest 无发送权限',
  'push.integrateMint': '生成',
  'push.integrateSend': '发送',
  'push.integrateCount': '预估命中',
  'push.integrateCountWhy': '同一条查询，不入队',
  'push.integratePoll': '结果',
  'push.integratePollWhy': '发送返回 sendId。sent = 厂商已受理。delivered = 设备已回执。',
  'push.retry': '重试',
  'push.readinessTitle': '配置自检',
  'push.level.blocked': '发不出去',
  'push.level.warn': '有缺口',
  'push.level.info': '提示',
  'push.check.no-device': '无已注册设备',
  'push.fix.no-device': '调用 sentori.push.register()。已失效 {quarantined} 台。',
  'push.check.no-credential': '{provider} · {devices} 台 · 无凭证',
  'push.fix.no-credential': '未配置前无法投递',
  'push.check.queue-stalled': '{queued} 条排队 · 最久 {minutes} 分钟',
  'push.fix.queue-stalled': 'worker 每 5 秒取一次。检查服务端推送是否启用。',
  'push.check.no-identity': '{live} 台 · 无身份',
  'push.fix.no-identity': '调用 sentori.user()。按人、按 issue 定向命中 0 台。',
  'push.check.no-traits': '{live} 台 · 无用户属性',
  'push.fix.no-traits': 'sentori.user({ id, traits })。属性条件命中 0 台。',
  'push.check.no-metadata': '{live} 台 · 无设备信息',
  'push.fix.no-metadata': 'push.register({ metadata })。版本条件命中 0 台。',
  'push.check.credential-unused': '{provider} 凭证 · 无对应设备',
  'push.fix.credential-unused': '若应有设备，说明 SDK 注册成了别的厂商',
  'push.check.mass-quarantine': '已失效 {quarantined} 台 · 存活 {live} 台',
  'push.fix.mass-quarantine': '通常是凭证指向了错误的 app 或 Apple host',
  'push.check.all-failing': '24 小时内 {failed} 条全部失败',
  'push.fix.all-failing': '厂商返回：{reason}',
  'push.check.apns-mixed-env': '{live} 台中 {sandbox} 台在 Apple sandbox',
  'push.fix.apns-mixed-env': '按设备 env 分别投递。单密钥通用。',
  'crashFree.scope': '所选 App 和环境最近 24 小时的会话；不受问题、版本和标签筛选影响',
  'crashFree.title': '无崩溃会话占比',
  'crashFree.thin': '会话太少，这个精度说明不了问题',
  'crashFree.counts': '{total} 个会话中 {crashed} 个崩溃',
  "crashFree.empty": "此时段暂无会话数据",
  'crashFree.users': '{pct}% 的用户没遇到崩溃',
  'crashFree.usersEmpty': '还没有识别到人',
  'crashFree.usersTitle': '最近 {hours} 小时内至少开过一次 session 的用户。跑了两个版本的人只算一次。',
  'crashFree.sessionsTitle': '最近 {hours} 小时内开始的 session。一次启动算一个 session，同一个人启动十次就是十个。',
  'health.usersTitle': '最近 24 小时发过任何事件的独立用户数，不只是遇到问题的那些',
  'crashFree.trendFrom': '{hours} 小时前',
  'crashFree.trendLow': '最低 {pct}%',
  'crashFree.trendTitle':
    '最近 {hours} 小时每段的无崩溃会话占比，纵轴从 {low}% 起。线断开的地方是那段没有 session，不是那段没崩溃。',
  'crashFree.window': '近 {hours} 小时',
  'platform.unknown': '未知（SDK 比服务端新）',
  'platform.weapp': '微信小程序',
  'releases.legend': '符号化',
  'releases.legendBroken': "含无效文件",
  'releases.crashFree': '无崩溃',
  'releases.crashFreeNone': '没有 session',
  'releases.crashFreeTitle':
    '最近 30 天，这个版本的 {sessions} 个 session 里有 {pct}% 没崩溃。session 由会发的 SDK 上报；一个都没有的版本显示短横而不是比率。',
  'releases.delete': '删除版本',
  'releases.deleteConfirm': '删除 {name}？符号化物料一并删除，该版本的调用栈在重新上传前无法还原。',
  'releases.deleteFailed': '版本删除失败',
  'releases.emptyTitle': '还没有版本',
  'releases.loadFailed': '版本列表加载失败',
  'replay.empty': '该录屏没有帧',
  'replay.frameAlt': '{t} 秒时的帧',
  'replay.loadFailed': '录屏加载失败',
  'replay.pause': '暂停',
  'replay.play': '播放',
  'replay.scrubber': '录屏进度',
  'replay.title': '会话回放',
  'releases.noArtifacts': '无符号化物料。调用栈保持混淆：',

  'settings.adminEmail': '管理员邮箱',
  'settings.auditLoadFailed': '审计日志加载失败',
  'settings.changePassword': '修改密码',
  'settings.createAdmin': '创建管理员',
  'settings.createProject': '创建',
  'settings.currentPassword': '当前密码',
  'settings.deleteAdminConfirm': '删除管理员 {email}？其会话将立即结束。',
  'settings.deleteProjectConfirm': '删除项目 {name}？其全部事件和 issue 一并删除。',
  'settings.initialPassword': '初始密码（8 位以上）',
  'settings.language': '语言',
  'settings.mintToken': '生成',
  'settings.newPassword': '新密码（至少 12 个字符）',
  'settings.projectName': '项目名',
  'settings.revoke': '吊销',
  'settings.revokeConfirm': '吊销 token {name}？使用它的客户端会立即停止上报。',
  'settings.revoked': '已吊销',
  'settings.save': '保存',
  'settings.saved': '已保存',
  'settings.tab.account': '账号',
  'settings.roleOwnerScope': '全部项目，外加管理员、令牌和审计日志',
  'settings.roleAdminScope': '只有下面勾选的项目',
  'settings.tab.audit': '审计',
  'settings.tab.notifications': '通知',
  'settings.tab.push': '推送',
  'settings.tab.tokens': 'Token',
  'settings.tab.users': '管理员',
  'settings.colAction': '操作',
  'settings.colActor': '操作者',
  'settings.colCreated': '创建于',
  'settings.colLastLogin': '最近登录',
  'settings.colRole': '角色',
  'settings.colTarget': '对象',
  'settings.colToken': 'token',
  'settings.colWhen': '时间',
  'settings.fieldProject': '项目',
  'settings.fieldScope': '权限',
  'settings.tokenName': 'token 名',
  'settings.tokenOnce': '仅显示一次。请立即复制。',
  'settings.usersLoadFailed': '管理员列表加载失败',
  'strip.inspectHint': "悬停或聚焦标记以查看详情",
  'stack.sourceCount': "{total} 帧中有 {n} 帧已关联源码",
  'releaseView.identifier': '原始版本标识',
  'stack.debugFiles': "检查此版本的调试文件",
  'stack.nativeSourceMissing': "定位源码需要与本次构建 UUID 匹配的调试文件，代码预览还需要该版本的源码包",
  'stack.sourceMissing': "此帧尚无源码预览，请检查该版本的 source map 或源码包",
  'stack.sourceReady': "源码",
  'stack.sourceUnavailable': "无源码预览",
  'stack.locationUnresolved': "未定位源码",
  'stack.locationMissing': "此帧尚未解析出源文件和行号，请检查该版本的调试文件",
  'stack.nativeLocationMissing': "此帧尚未解析出源文件和行号，请核对调试文件是否与本次构建 UUID 匹配",
  'stack.binaryUuid': "构建 UUID",
  'stack.address': "地址",
  'stack.libraryFrames': '{n} 个库帧',
  'stack.libraryFramesOpen': '库帧',
  'stack.minified': 'minified',
  'stack.truncated': '… 还有 {n} 帧',

  'table.empty': '暂无内容',

  'shell.bootFailed': '会话加载失败',
  'shell.projectsFailed': '项目列表加载失败',
  'shell.loading': '加载中…',

  'strip.events': '事件',
  'strip.frames': '帧',
  'strip.signals': '行为',
  'theme.dark': '深色',
  'theme.label': '主题',
  'theme.light': '浅色',
  'theme.system': '跟随系统',
  'shell.roleAdmin': '管理员',
  'shell.roleOwner': '所有者',
  "transfer.title": "项目迁移",
  "transfer.description": "从自托管 Sentori 迁往 Cloud 或另一实例，确认实时数据后再完成迁移",
  "transfer.prepare": "连接两个实例",
  "transfer.prepareHint": "分别以所有者身份打开两个实例的此页面。在目标实例下载身份文件，再到源实例载入并开始迁移",
  "transfer.saveIdentity": "保存实例身份文件",
  "transfer.receive": "接收迁移",
  "transfer.start": "开始迁移",
  "transfer.scope": "项目迁移范围",
  "transfer.scopeHint": "项目历史、事件、会话、回放文件、发布和任务通过加密包迁移。Token、密码、成员权限、Push 凭据和自动化设置需要在目标端重新配置",
  "transfer.limit": "每次上传上限为 1 GiB，可分批选择较少项目。单个项目超过此上限时需要运维协助，此页面无法导入。Cloud 的项目和存储配额也适用",
  "transfer.empty": "暂无迁移记录",
  "transfer.id": "迁移 ID",
  "transfer.source": "源实例",
  "transfer.target": "目标实例",
  "transfer.step.copy": "复制历史",
  "transfer.step.cutover": "最终复制与切换",
  "transfer.step.evidence": "验证实时数据",
  "transfer.sourceHint": "先在源端继续服务时导出初始副本，目标端导入后再封存源端并导出最终副本。保留源实例运行，以接收旧客户端请求",
  "transfer.targetHint": "先导入初始副本，再导入源端封存后的最终包。最终导入成功后方可启用。历史数据不能用于证明 SDK 已切换",
  "transfer.saveDescriptor": "保存迁移说明文件",
  "transfer.sdkHint": "最终导入后，在目标端创建新的采集 Token 并更新 SDK 地址和项目配置。另行配置 Push 与自动化",
  "transfer.evidenceHint": "此处显示启用后每个项目实际收到的首个 SDK 新事件。等待所有项目收到事件后再验证",
  "transfer.waitingEvent": "等待 SDK 新事件",
  "transfer.copyPackage": "初始副本",
  "transfer.finalPackage": "最终副本",
  "transfer.forwarded": "转发成功请求数",
  "transfer.failed": "转发失败请求数",
  "transfer.expires": "转发到期时间",
  "transfer.lastSeen": "最近转发请求",
  "transfer.noTraffic": "尚无转发请求",
  "transfer.rollback": "回退与数据保全方案",
  "transfer.invalidDescriptor": "请载入当前目标的有效文件；从源端开始时还需选择至少一个项目",
  "transfer.sourceCreateHint": "载入从目标实例下载的身份文件，然后选择要迁移的项目",
  "transfer.targetCreateHint": "载入从源实例下载的迁移说明文件，其中的目标必须是当前实例",
  "transfer.identityFile": "目标身份文件",
  "transfer.descriptorFile": "迁移说明文件",
  "transfer.identityContent": "目标身份内容",
  "transfer.descriptorContent": "迁移说明内容",
  "transfer.incomplete": "请填写必填项后继续",
  "transfer.packageHint": "请妥善保存加密包及其恢复密钥。每次导出可使用新密钥，导入时必须使用对应包的密钥",
  "transfer.sealHint": "封存会等待已接纳的写入完成，然后停止选中源项目的新写入。下一步导出最终副本。配置转发前旧 SDK 请求会重试。此页面无法撤销封存",
  "transfer.activateHint": "启用后，导入的项目开始接收新写入。后续如需回退，必须先保全并核对合并目标端新增数据，再重新开放源端",
  "transfer.rollbackHint": "记录负责人、备份位置、目标新增数据保全方式，以及流量回切前的数据核对合并步骤（30–8,000 字节）",
  "transfer.cutoverAck": "我已制定数据保全方案，并理解回切前必须核对合并目标端新增数据",
  "transfer.sdkAck": "我已更新 SDK 地址、项目与 Token。旧客户端仍需转发时，会继续保留源实例运行",
  "transfer.cancelAck": "在切换前取消本次迁移；目标端已导入的暂存项目将被移除",
  "transfer.tailHint": "使用最终导入后在目标端新建的采集 Token。源端核验目标身份后才会转发旧客户端请求。仅转发遥测数据，Push 需单独配置。转发最长 90 天，可在此续期",
  "transfer.targetOrigin": "目标 HTTPS 源地址",
  "transfer.targetToken": "目标端新采集 Token",
  "transfer.days": "转发天数（1–90）",
  "transfer.action.export_copy": "导出初始副本",
  "transfer.action.seal": "封存源端写入",
  "transfer.action.export_final": "导出最终副本",
  "transfer.action.upload_copy": "导入初始副本",
  "transfer.action.upload_final": "导入最终副本",
  "transfer.action.activate": "启用目标端",
  "transfer.action.verify": "验证已收到的事件",
  "transfer.action.complete": "完成迁移",
  "transfer.action.cancel": "取消迁移",
  "transfer.action.tail": "转发旧客户端",
  "transfer.state.copying": "等待初始副本",
  "transfer.state.copied": "初始副本就绪",
  "transfer.state.sealed": "源端已封存",
  "transfer.state.ready": "最终副本就绪",
  "transfer.state.active": "目标端已启用",
  "transfer.state.observing": "观察实时流量",
  "transfer.state.completed": "迁移已验证",
  "transfer.state.cancelled": "已取消",
  "transfer.state.attention": "需要处理",

  "transfer.ownerOnly": "仅实例所有者可管理项目迁移",

  "filters.appType": "App 类型",
  "filters.platform": "平台",
  "filters.source": "标签来源",
  "filters.context": "上下文",
  "filters.tags": "事件标签",
  "filters.key": "标签名",
  "filters.value": "标签值",
  "filters.add": "添加条件",
  "filters.active": "已选标签条件",
  "filters.remove": "移除 {key} 条件",
  "filters.emptyValue": "（空值）",
  "filters.sameEvent": "所有条件须匹配同一条事件；appType 等业务维度可在标签中选择",
  "filters.invalid": "筛选链接无效，请清除筛选后重试",

  "charts.dimension": "观测项",
  "charts.plot": "图表",
  "charts.table": "数据表",
  "charts.export": "导出 CSV",
  "charts.failed": "图表加载失败",
  "charts.empty": "暂无观测数据",
  "charts.emptyHint": "收到符合条件的数据后将在这里显示",
  "workbench.overview": "概览",
  'workbench.filteredTasks': '所有符合筛选条件的任务',
  "workbench.activeTasks": "待处理任务",
  "workbench.reviewTasks": "待评审与验证",
  "workbench.doneTasks": "已完成",
  "workbench.overdueTasks": "已逾期",
  "workbench.tasksEmptyHint": "新建任务，或从问题发起修复，持续跟进评审与验证",
  "workbench.firstTask": "创建一个任务",
  "workbench.monitoredServices": "监控服务",
  "workbench.projectScope": "当前项目",
  "workbench.openIncidents": "未恢复故障",
  "workbench.searchServices": "搜索服务",
  "workbench.monitorsEmptyHint": "添加服务检查地址，持续查看可用性、响应耗时与故障恢复记录",
  "workbench.firstMonitor": "添加第一个监控",
  "workbench.monitorLatencyHint": "最近成功检查的响应耗时；失败请求保留为空缺，检查结果见下方记录",
  "workbench.instrumentsDescription": "汇总事件活动、启动性能与埋点信号，定位版本中的变化",
  "workbench.searchInstruments": "搜索名称或版本",
  "workbench.window": "观测时间范围",
  "workbench.lastHours": "最近 {hours} 小时",
  "workbench.launchChartHint": "最近 {hours} 小时各版本启动耗时分位数，排除预热启动",
  "workbench.eventActivity": "事件活动趋势",
  "workbench.receivedWindow": "最近 {hours} 小时收到的数据",
  "workbench.topTraces": "所选时间范围内最活跃的 12 个追踪点",
  "workbench.errorEvents": "错误事件",
  "workbench.warningEvents": "警告事件",
  "workbench.cumulativeHint": "名称与版本条件下的累计计数，最多显示 200 行，图表展示前 12 项；时间范围用于事件趋势、追踪和启动性能",
  "workbench.passed": "通过",
  "workbench.failed": "失败",
  "workbench.probeFires": "探针触发",
  "workbench.registered": "注册时间",
  "workbench.traceWindow": "最近 {hours} 小时收到的数据，最多显示 200 个追踪点",

};
